import React from 'react'
import { Row, Col, Container } from 'reactstrap'

import Layout from '../components/layout'
import Billboard from '../components/Billboard'
import FeaturedArticles from '../components/pages/index/FeaturedArticles'

import cfLogo from '../images/cloudfront/cf-logo.svg'
import cfNetworkMap from '../images/cloudfront/cf-network-map.png'
import GreenCheckList from '../components/GreenCheckList'
import Seo from '../components/seo'
import WhyCloudFront from '../components/pages/cloudfront/why'
import Assessment from '../components/pages/mobile-workforce/assessment'
import { CONTACT_ROUTE } from '../routes'

const CloudFrontPage = () => (
  <Layout>
    <Seo
      title="AWS CloudFront"
      description="Increase your application's performance by utilizing AWS CloudFront"
    />

    <Billboard>
      <div className="Billboard__top CsBillboard CfBillboard">
        <div className="CsBillboard__left">
          <h1 className="Billboard__title">Amazon CloudFront</h1>
          <div className="Billboard__lead">
            CloudFront provides acceleration for both dynamic and static
            content.
          </div>

          <div className="Billboard__cta">
            <a href={CONTACT_ROUTE} className="btn btn-orange btn-lg">
              Get Started
            </a>
          </div>
        </div>

        <div className="CsBillboard__right">
          <img src={cfLogo} alt="AWS CloudFront Logo" />
        </div>
      </div>
    </Billboard>

    <section className="CsStats">
      <Container>
        <Row>
          <Col md="4">
            <div className="CsStat">
              <div className="CsStat__count">225+</div>
              <div className="CsStat__label">Points of Presence</div>
            </div>
          </Col>

          <Col md="4">
            <div className="CsStat">
              <div className="CsStat__count">Across 90+</div>
              <div className="CsStat__label">Cities and 47 Countries</div>
            </div>
          </Col>

          <Col md="4">
            <div className="CsStat CsStat--last">
              <div className="CsStat__count">With Millions</div>
              <div className="CsStat__label">of Customers Served</div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>

    <section className="CsFeatureBlock CsFeatureBlock--first">
      <Container>
        <div className="CsFeatureBlock__inner">
          <div className="CsFeatureBlock__left">
            <div className="CsFeatureBlock__img">
              <img
                src={cfNetworkMap}
                className="CsFeatureBlock__img--white"
                alt="CloudFront Network Map"
              />
            </div>
          </div>

          <div className="CsFeatureBlock__right">
            <h2 className="CsFeatureBlock__title">AWS Global Edge Network</h2>
            <div className="CsFeatureBlock__lead">
              AWS operates a private network backbone between AWS Regions and
              Edge Locations which allows customers to avoid congestion of
              public internet.
            </div>

            <GreenCheckList
              className="CsFeatureBlock__features"
              items={[
                'Improves Security',
                'Improves Performance',
                'Reduces Cost',
              ]}
            />
          </div>
        </div>
      </Container>
    </section>

    <WhyCloudFront />
    <Assessment />
    <FeaturedArticles />
  </Layout>
)

export default CloudFrontPage
